import { TextCell } from '@common/components/TextCell';
import { formatCurrency } from '@common/lib/currency';

interface EstRetailPriceCellProps {
	/** The estimated retail price as a number */
	estimatedRetailPrice?: number;
}

export const EstRetailPriceCell = ({ estimatedRetailPrice }: EstRetailPriceCellProps): React.ReactNode => {
	return <TextCell value={estimatedRetailPrice != null ? formatCurrency(estimatedRetailPrice) : undefined} />;
};
